import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

export const P = {
  invoiceLink: (b) => api.post("/payments/invoices/link", b).then((r) => r.data),
  invoiceLinks: () => api.get("/payments/invoices/links").then((r) => r.data.links),
  publicInvoice: (token) => api.get(`/public/pay/${token}`).then((r) => r.data),
  invoiceCheckout: (token) => api.post(`/public/pay/${token}/checkout`, { origin_url: window.location.origin }).then((r) => r.data),
  checkout: (lookup_key) => api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin }).then((r) => r.data),
  status: (sid) => api.get(`/payments/status/${sid}`).then((r) => r.data),
  me: () => api.get("/payments/me").then((r) => r.data),
  plans: () => api.get("/payments/plans").then((r) => r.data.plans),
  cancel: () => api.post("/payments/cancel").then((r) => r.data),
  resume: () => api.post("/payments/resume").then((r) => r.data),
};

export const payUrl = (token) => `${window.location.origin}/pay/${token}`;

export function useInvoicePayments(invoices, setInvoices, setLinks) {
  const seen = useRef("");
  useEffect(() => {
    let stop = false;
    const tick = async () => {
      try {
        const links = await P.invoiceLinks();
        if (stop) return;
        setLinks(Object.fromEntries(links.map((l) => [l.invoice_id, l])));
        const paid = links.filter((l) => l.status === "paid").map((l) => l.invoice_id);
        const key = paid.join(",");
        if (key && key !== seen.current) {
          seen.current = key;
          setInvoices((all) => all.map((inv) => (paid.includes(inv.id) && inv.status !== "Paid" ? { ...inv, status: "Paid", paid_via: "stripe" } : inv)));
        }
      } catch (e) { /* offline */ }
    };
    tick();
    const t = setInterval(tick, 15000);
    return () => { stop = true; clearInterval(t); };
  }, []); // eslint-disable-line
}
